import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectSupplierInfo } from "../../../../store/slices/supplierInfoSlice";
import InfoRow from "./InfoRow";
import InfoSection from "./InfoSection";
import { useSectionNumbering } from "../hooks/useSectionNumbering";

const ContractSummarySection = () => {
	const { t } = useTranslation();
	const { sectionNumbers } = useSectionNumbering();

	const supplierInfo = useSelector(selectSupplierInfo);
	const { amounts } = supplierInfo || { amounts: {} };

	return (
		<InfoSection>
			<InfoRow
				label={<b>{sectionNumbers.contractAmount}. {t("supplier-info.contract-amount-net")}</b>}
				value={amounts?.contractAmount || 0}
				name="contractAmount"
				suffix="€"
				isBold={true}
			/>
			<InfoRow
				label={`${sectionNumbers.confirmedChanges}. ${t("supplier-info.confirmed-changes")}`}
				value={amounts?.nachtraegeConfirmed || 0}
				name="confirmedChanges"
				suffix="€"
			/>
			<InfoRow
				label={<b>{sectionNumbers.currentOrderAmount}. {t("supplier-info.current-order-amount")}</b>}
				value={amounts?.totalAmount || 0}
				isBold={true}
				name="currentOrderAmount"
				suffix="€"
			/>
		</InfoSection>
	);
};

export default ContractSummarySection;
